import React from 'react';
import './style.scss';

export default function Banner() {
  return (
    <div className='banner'>
      <img src={require('../../img/bannerHome.jpg')} alt='' />
    </div>
  );
}
